export default Object.freeze({
    IGNORE_REGION_REDIRECT: 'ignoreRegionRedirect',
    REDIRECT_TO_REGION: 'redirectToRegion',
    REDIRECT_TO_REGION_OVERRIDE: 'redirectToRegionOverride',
    USER_TODAY_LOGIN_COUNTER: 'userTodayLoginCounter',
    PURCHASED_GUEST_GALLERIES: 'purchasedGuestGalleries',
    XTRACKING_DEVICE_ID: 'erob_d',
    XTRACKING_SESSION_ID: 'erob_s',
    NATIVE_ADVERT_IMPRESSION_COUNT: 'nativeImpressionCount',
    TOASTR_ERROR: 'toastrError',
    TOASTR_SUCCESS: 'toastrSuccess',
    JWT: 'jwt',
    SHOW_STORIES: 'showStories',
});
